import { createIcon } from '@chakra-ui/react';

export const RedFlagIcon = createIcon({
  displayName: 'RedFlagIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.0134 8.22065L11.2 7.40732C11.0067 7.24065 10.8934 6.99398 10.8867 6.72065C10.8734 6.42065 10.9934 6.12065 11.2134 5.90065L12.0134 5.10065C12.7067 4.40732 12.9667 3.74065 12.7467 3.21398C12.5334 2.69398 11.8734 2.40732 10.9 2.40732H3.93335V1.83398C3.93335 1.56065 3.70668 1.33398 3.43335 1.33398C3.16002 1.33398 2.93335 1.56065 2.93335 1.83398V14.1673C2.93335 14.4406 3.16002 14.6673 3.43335 14.6673C3.70668 14.6673 3.93335 14.4406 3.93335 14.1673V10.914H10.9C11.86 10.914 12.5067 10.6207 12.7267 10.094C12.9467 9.56732 12.6934 8.90732 12.0134 8.22065Z"
          fill="#F0543F"
        />
      </svg>
    </>
  ),
});
